<template>
  <div>
    <div class="row border-bottom border-bottom white-bg dashboard-header">
      <div class="col-lg-5 col-xl-3">
        <h2>
          Personal Information Management
        </h2>
      </div>
    </div>

    <!-- Permission Profile Search/Filter -->
    <div class="row">
      <div class="col-md-12">
        <profile-permission-filter-card :fixedHeight="false"
          @search-profile="$emit('search-profile', $event)"
          @display-profile="$emit('display-profile')"
          :loading-profile="loadingProfile"
          :searching="searching"
          :results="results"
        />
      </div>
    </div>

  </div>
</template>

<script>
import ProfilePermissionFilterCard from '@/components/permission/PermissionFilterCard';

export default {
  name: 'PermissionDashboard',
  components: {
    ProfilePermissionFilterCard,
  },
  data: () => ({
    displayProfile: true,
  }),
  props: {
    searching: {
      type: Boolean,
      default: false,
    },
    loadingProfile: {
      type: Boolean,
      default: false,
    },
    results: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-header {
  margin-bottom: 35px;
}
</style>


// WEBPACK FOOTER //
// Dashboard.vue?4b3262f9